var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-wrapper"},[(_vm.bActive && !_vm.disabled)?_c('a',{staticClass:"box-delete",class:{ enabled: !_vm.disabled },style:({
      top: _vm.bTop - 15 + 'px',
      left: _vm.bLeft + _vm.bWidth - 15 + 'px',
    }),on:{"click":_vm.removeMyself}},[_c('bg-icon',{attrs:{"name":"fdelete"}})],1):_vm._e(),(_vm.bLabel)?_c('div',{staticClass:"label",style:({
      top: _vm.bTop + 'px',
      left: _vm.bLeft + 'px',
      width: _vm.bWidth + 'px',
    }),on:{"click":_vm.selectBox}},[_c('input',{attrs:{"type":"text","placeholder":_vm.bLabel},domProps:{"value":_vm.bLabel},on:{"change":function($event){return _vm.$emit('updated', $event.target.value, _vm.bIndex)}}})]):_vm._e(),_c('div',{staticClass:"box",class:{ active: _vm.bActive },style:({
      top: _vm.bTop + 'px',
      left: _vm.bLeft + 'px',
      width: _vm.bWidth + 'px',
      height: _vm.bHeight + 'px',
    }),on:{"mousedown":_vm.selectBox}})])
}
var staticRenderFns = []

export { render, staticRenderFns }